import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { getAllCollections } from "../../redux/apiCall/collectionCall";
import axios from "axios";
import AdminFormLayout from "../components/AdminFormLayout";
import ButtonComponent from "../../components/ButtonComponent";
import ReactQuill from "react-quill-new";
import "react-quill-new/dist/quill.snow.css";
import { apiUrl } from "../../config/api";
import {
  appendImages,
  getAdminUploadHeaders,
  getApiErrorMessage,
} from "../../utils/adminApi";

const AddNotSale = () => {
  const dispatch = useDispatch();
  const collections = useSelector((state) => state.collection.collections);

  const navigate = useNavigate();

  useEffect(() => {
    dispatch(getAllCollections());
  }, [dispatch]);

  // Initialize formData only when categories change (on mount)
  useEffect(() => {
    if (collections.length > 0) {
      setFormData((prevData) => ({
        ...prevData,
        collectionId: collections[0]._id,
      }));
    }
  }, [collections]);

  const [formData, setFormData] = useState({
    name: "",
    description: "",
    images: [],
    collectionId: "",
  });

  const handleInputChange = (e) => {
    const { name, value, files } = e.target;
    if (name === "images") {
      if (files.length > 5) {
        toast.error("You can upload a maximum of 5 images.");
        return;
      }
      setFormData((prevData) => ({ ...prevData, images: Array.from(files) }));
    } else {
      setFormData((prevData) => ({ ...prevData, [name]: value }));
    }
  };

  const handleDescriptionChange = (value) => {
    setFormData((prevData) => ({
      ...prevData,
      description: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const descriptionText = formData.description.replace(/<[^>]*>/g, "").trim();
    if (!descriptionText) {
      toast.error("Product description is required.");
      return;
    }

    if (formData.images.length === 0) {
      toast.error("Please select at least one image.");
      return;
    }

    try {
      const productData = new FormData();
      productData.append("name", formData.name);
      productData.append("description", formData.description);
      productData.append("collectionId", formData.collectionId);
      appendImages(productData, formData.images);

      await axios.post(apiUrl("/api/products"), productData, {
        headers: getAdminUploadHeaders(),
      });
      toast.success("Product added successfully!");
      navigate("/admin/notsale");
    } catch (error) {
      console.log(error);
      toast.error(getApiErrorMessage(error, "Error adding product. Please try again."));
    }
  };

  return (
    <AdminFormLayout title="Add Not For Sale Product" backTo="/admin/notsale" backLabel="Back to Not For Sale">
        <form onSubmit={handleSubmit} encType="multipart/form-data">
          <div className="admin-form-group">
            <label htmlFor="name">Product Name</label>
            <input
              type="text"
              className="form-control admin-all-forms-inputs"
              id="name"
              name="name"
              value={formData.name}
              onChange={handleInputChange}
              required
            />
          </div>

          <div className="admin-form-group">
            <label htmlFor="description">Product Description</label>
            <ReactQuill
              id="description"
              theme="snow"
              value={formData.description}
              onChange={handleDescriptionChange}
              className="admin-all-forms-inputs-quill"
            />
          </div>

          <div className="admin-form-group">
            <label htmlFor="images">Product Images (max 5)</label>
            <input
              type="file"
              className="form-control admin-all-forms-inputs"
              id="images"
              name="images"
              accept="image/*"
              onChange={handleInputChange}
              multiple
              required
            />
          </div>

          <div className="admin-form-group">
            <label htmlFor="collectionId">Product Collection</label>
            <select
              className="form-select admin-all-forms-inputs"
              id="collectionId"
              name="collectionId"
              value={formData.collectionId}
              onChange={(e) => {
                // Update categoryId based on the selected option
                setFormData({ ...formData, collectionId: e.target.value });
              }}
              required
            >
              {collections.map((collection) => (
                <option key={collection._id} value={collection._id}>
                  {collection.collectionName}
                </option>
              ))}
            </select>
          </div>

          <ButtonComponent type="submit">Add Product</ButtonComponent>
        </form>
    </AdminFormLayout>
  );
};

export default AddNotSale;
